/* Seven Thousand — Lap Timer delta display simulator.
   Models the delta page of lap_timer firmware v0.32: a signed gap to your own
   best lap, printed to three decimals, with a symmetrical centre-origin bar
   over a five-tick scale. Green under, red over — exactly as updateDelta()
   decides it on the device. One hot lap plays on a loop.

   Shared verbatim between the design component and the Shopify asset. */
(function (global) {
  'use strict';

  var GREEN = '#2ecc71';   /* DELTA_GREEN 0x2ECC71 */
  var RED   = '#e74c3c';   /* DELTA_RED   0xE74C3C */
  var RANGE = 1.0;         /* bar clamps at +/-100 -> +/-1.000 s */

  /* One lap. `to` is the delta the segment eases toward over `d` seconds;
     hold segments sit on the value they arrived at. Short durations read as
     sudden time loss, long ones as a gradual drift. */
  var LAP = [
    { to:  0.000, d: 1.2, label: 'LAP START' },
    { to: -0.062, d: 2.0, label: 'SECTOR 1' },
    { to: -0.234, d: 2.4, label: 'T3 APEX — GAINING' },
    { to: -0.311, d: 2.2, label: 'BACK STRAIGHT' },
    { to: -0.140, d: 1.6, label: 'T7 ENTRY' },
    { to:  0.412, d: 1.1, label: 'LOCKUP — TIME LOST' },
    { hold: true,  d: 1.3, label: 'OFF LINE' },
    { to:  0.268, d: 2.2, label: 'RECOVERING' },
    { to:  0.043, d: 2.0, label: 'SECTOR 3' },
    { to: -0.058, d: 1.8, label: 'FINAL CORNER' },
    { to: -0.198, d: 2.2, label: 'ACROSS THE LINE' },
    { hold: true,  d: 2.4, label: 'LAP COMPLETE — NEW BEST' },
    { to:  0.000, d: 1.0, label: 'DELTA RESET' }
  ];

  function ease(p) { return p < 0.5 ? 2 * p * p : 1 - Math.pow(-2 * p + 2, 2) / 2; }
  function fmt(v) { return (v < 0 ? '-' : '+') + Math.abs(v).toFixed(3); }

  function mount(root, opts) {
    opts = opts || {};
    var valueEl = opts.valueEl, barEl = opts.barEl, captionEl = opts.captionEl || null;
    if (!valueEl || !barEl) return { destroy: function () {} };

    var total = 0;
    for (var i = 0; i < LAP.length; i++) total += LAP[i].d;

    var raf = null, last = null, stopped = false, running = false;
    var clock = 0, lastLabel = null, lastText = null;

    function valueAt(time) {
      var t = time % total, acc = 0, from = 0;
      for (var i = 0; i < LAP.length; i++) {
        var seg = LAP[i];
        if (t < acc + seg.d) {
          if (seg.hold) return { v: from, label: seg.label };
          var p = ease((t - acc) / seg.d);
          return { v: from + (seg.to - from) * p, label: seg.label };
        }
        acc += seg.d;
        if (!seg.hold) from = seg.to;
      }
      return { v: from, label: LAP[LAP.length - 1].label };
    }

    function paint(v, label) {
      var color = v < 0 ? GREEN : RED;
      var text = fmt(v);
      if (text !== lastText) { valueEl.textContent = text; lastText = text; }
      valueEl.style.color = color;

      /* symmetrical bar: grows out of the centre, clamped at the rail */
      var mag = Math.min(1, Math.abs(v) / RANGE) * 50;
      barEl.style.background = color;
      if (v < 0) { barEl.style.right = '50%'; barEl.style.left = 'auto'; }
      else { barEl.style.left = '50%'; barEl.style.right = 'auto'; }
      barEl.style.width = mag.toFixed(2) + '%';
      barEl.style.opacity = Math.abs(v) < 0.002 ? '0' : '1';

      if (captionEl && label !== lastLabel) { captionEl.textContent = label; lastLabel = label; }
    }

    function frame(now) {
      if (stopped) return;
      if (last === null) last = now;
      var dt = Math.min(0.05, (now - last) / 1000);
      last = now;
      clock += dt;
      var s = valueAt(clock);
      /* sub-millisecond telemetry noise, so the readout never looks tweened */
      var jitter = Math.abs(s.v) < 0.002 ? 0 : Math.sin(clock * 37.0) * 0.0015;
      paint(s.v + jitter, s.label);
      raf = global.requestAnimationFrame(frame);
    }

    function play() {
      if (running || stopped) return;
      running = true; last = null;
      raf = global.requestAnimationFrame(frame);
    }
    function pause() {
      running = false;
      if (raf) global.cancelAnimationFrame(raf);
      raf = null;
    }

    paint(0, LAP[0].label);

    var io = null;
    if (global.IntersectionObserver) {
      io = new global.IntersectionObserver(function (e) {
        if (e[0].isIntersecting) play(); else pause();
      }, { threshold: 0.2 });
      io.observe(root);
    } else play();

    return {
      destroy: function () {
        stopped = true;
        pause();
        if (io) io.disconnect();
      }
    };
  }

  global.SevenThousandDelta = { mount: mount, lap: LAP, range: RANGE };
})(window);